import { UserModel } from '@/models';
import { LiveStreamProductTypes, ProductRangeTypes } from '@/features/livestream/detail/const';

export const productsRangeBuilder = (products: LiveStreamProductTypes[]) => {
  if (!Array.isArray(products)) {
    return [];
  }

  let arr = [] as ProductRangeTypes[];
  let p = products.sort((a, b) => a.played - b.played);
  for (let i = 0; i < p.length; i++) {
    const { played: nextRangeStartSecond } = p[i + 1] || {};
    const { played: rangeStartSecond } = p[i];
    let rangeEndSecond = 86400;
    if (nextRangeStartSecond) {
      rangeEndSecond = nextRangeStartSecond;
    }
    arr.push({
      product: p[i],
      range: [rangeStartSecond, rangeEndSecond],
    });
  }
  return arr;
};

export const getCommentAuthor = (user: any, staff: any) => {
  if (!user && !staff) return { avatar: '/logo-mini.jpeg', fullname: '#' };
  const author = user || staff;
  if (author) {
    const { avatar, fullname } = author;

    return { avatar, fullname };
  }
  return { avatar: '', fullname: '#' };
};
